import { render, staticRenderFns } from "./CategorySecondList.vue?vue&type=template&id=562d16ac&scoped=true&"
import script from "./CategorySecondList.vue?vue&type=script&lang=js&"
export * from "./CategorySecondList.vue?vue&type=script&lang=js&"
import style0 from "./CategorySecondList.vue?vue&type=style&index=0&id=562d16ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d16ac",
  null
  
)

export default component.exports